<template>
  <div class="financeiro-hub-container">
    <!-- Cabeçalho do Hub -->
    <div class="hub-header mb-6">
      <div class="header-top flex flex-col md:flex-row md:items-center md:justify-between">
        <div>
          <h2 class="text-2xl font-bold text-gray-800 flex items-center mb-1">
            <span class="header-icon mr-2">
              <vs-icon icon="account_balance_wallet" size="26px" color="#002750"></vs-icon>
            </span>
            Módulo Financeiro
          </h2>
          <p class="text-sm text-gray-500">
            Painel unificado de gestão financeira, faturamento e auditoria.
          </p>
        </div>

        <!-- Filtros por Categoria e Busca Rápida -->
        <div class="header-actions mt-4 md:mt-0 flex flex-col sm:flex-row sm:items-center">
          <div class="categoria-chips flex flex-wrap gap-1 mb-2 sm:mb-0 sm:mr-3">
            <button
              v-for="cat in categorias"
              :key="cat.id"
              class="chip-btn"
              :class="{ 'chip-btn-active': categoriaAtiva === cat.id }"
              type="button"
              @click="categoriaAtiva = cat.id"
            >
              {{ cat.label }}
            </button>
          </div>

          <div class="busca-wrapper relative">
            <input
              v-model="filtroBusca"
              type="text"
              class="busca-input"
              placeholder="Buscar módulo..."
            />
            <span class="busca-icon">
              <vs-icon icon="search" size="18px" color="#8a94a6"></vs-icon>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Grid Responsivo com 10 Módulos -->
    <div v-if="itensFiltrados.length > 0" class="financeiro-grid">
      <div
        v-for="item in itensFiltrados"
        :key="item.id"
        class="card-fin-item"
        role="button"
        tabindex="0"
        @click="navegar(item.route)"
        @keydown.enter="navegar(item.route)"
      >
        <div class="card-header-bar flex items-center justify-between w-full mb-3">
          <span
            class="categoria-badge"
            :style="{ backgroundColor: item.badgeBg, color: item.badgeColor }"
          >
            {{ item.categoriaLabel }}
          </span>
          <span class="card-arrow-indicator">
            <vs-icon icon="arrow_forward" size="16px"></vs-icon>
          </span>
        </div>

        <div class="card-icon-box mb-3" :style="{ backgroundColor: item.badgeBg }">
          <vs-icon :icon="item.icon" size="32px" :color="item.color"></vs-icon>
        </div>

        <div class="card-body-content text-center w-full">
          <h3 class="card-title mb-1">{{ item.title }}</h3>
          <p class="card-description">{{ item.description }}</p>
        </div>
      </div>
    </div>

    <!-- Estado vazio quando busca não encontra resultados -->
    <div v-else class="empty-state-hub text-center p-8 bg-white rounded-lg shadow-sm">
      <div class="mb-3">
        <vs-icon icon="search_off" size="48px" color="#cbd5e1"></vs-icon>
      </div>
      <h4 class="text-lg font-semibold text-gray-700 mb-1">Nenhum módulo encontrado</h4>
      <p class="text-sm text-gray-500 mb-4">
        Não foram encontrados módulos para o termo "{{ filtroBusca }}".
      </p>
      <vs-button size="small" type="border" color="primary" @click="limparFiltros()">
        Limpar busca
      </vs-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FinanceiroHub',
  data() {
    return {
      filtroBusca: '',
      categoriaAtiva: 'todos',
      categorias: [
        { id: 'todos', label: 'Todos' },
        { id: 'fluxo', label: 'Fluxo & Caixa' },
        { id: 'fiscal', label: 'Faturamento & Fiscal' },
        { id: 'auditoria', label: 'Auditoria & DRE' }
      ],
      menuItems: [
        {
          id: 'caixa',
          title: 'CAIXA',
          route: '/caixa',
          method: 'Caixa',
          categoria: 'fluxo',
          categoriaLabel: 'Fluxo',
          icon: 'account_balance',
          color: '#002750',
          badgeBg: '#e8f0fe',
          badgeColor: '#1a73e8',
          description: 'Entradas, saídas e movimentações diárias'
        },
        {
          id: 'contas-pagar',
          title: 'CONTAS A PAGAR',
          route: '/notas-entrada',
          method: 'NotasEntrada',
          categoria: 'fluxo',
          categoriaLabel: 'Fluxo',
          icon: 'money_off',
          color: '#ea5455',
          badgeBg: '#fee2e2',
          badgeColor: '#dc2626',
          description: 'Obrigações, quitações e despesas com fornecedores'
        },
        {
          id: 'contas-receber',
          title: 'CONTAS A RECEBER',
          route: '/contas-receber',
          method: 'ContasReceber',
          categoria: 'fluxo',
          categoriaLabel: 'Fluxo',
          icon: 'attach_money',
          color: '#28c76f',
          badgeBg: '#dcfce7',
          badgeColor: '#15803d',
          description: 'Títulos, recebimentos e parcelamentos de clientes'
        },
        {
          id: 'cobranca',
          title: 'COBRANÇA',
          route: '/cobranca',
          method: 'Cobranca',
          categoria: 'fluxo',
          categoriaLabel: 'Fluxo',
          icon: 'thumbs_up_down',
          color: '#ff9f43',
          badgeBg: '#fef3c7',
          badgeColor: '#b45309',
          description: 'Régua de cobrança, notificações e devedores'
        },
        {
          id: 'boleto',
          title: 'BOLETOS',
          route: '/boleto',
          method: 'Boleto',
          categoria: 'fiscal',
          categoriaLabel: 'Fiscal',
          icon: 'receipt',
          color: '#7367f0',
          badgeBg: '#ede9fe',
          badgeColor: '#6d28d9',
          description: 'Emissão, registro e acompanhamento de boletos'
        },
        {
          id: 'nota',
          title: 'NOTAS',
          route: '/nota',
          method: 'Notas',
          categoria: 'fiscal',
          categoriaLabel: 'Fiscal',
          icon: 'description',
          color: '#00cfe8',
          badgeBg: '#e0f2fe',
          badgeColor: '#0369a1',
          description: 'Notas fiscais de serviço (NFS-e) e faturamento'
        },
        {
          id: 'contratos-faturamento',
          title: 'PARA FATURAR',
          route: '/contratos-faturamento',
          method: 'ParaFaturar',
          categoria: 'fiscal',
          categoriaLabel: 'Fiscal',
          icon: 'local_atm',
          color: '#009688',
          badgeBg: '#ccfbf1',
          badgeColor: '#0f766e',
          description: 'Contratos e ordens de serviço aptos para faturar'
        },
        {
          id: 'retorno',
          title: 'RETORNO',
          route: '/retorno',
          method: 'Retorno',
          categoria: 'fiscal',
          categoriaLabel: 'Fiscal',
          icon: 'cached',
          color: '#8b5cf6',
          badgeBg: '#f3e8ff',
          badgeColor: '#7e22ce',
          description: 'Importação e processamento de arquivos bancários'
        },
        {
          id: 'conferencia-diaria',
          title: 'CONFERÊNCIA DIÁRIA',
          route: '/conferencia-diaria-notas',
          method: 'ConferenciaDiaria',
          categoria: 'auditoria',
          categoriaLabel: 'Auditoria',
          icon: 'playlist_add_check',
          color: '#059669',
          badgeBg: '#d1fae5',
          badgeColor: '#047857',
          description: 'Auditoria diária de notas emitidas e protocolos'
        },
        {
          id: 'dre',
          title: 'DRE',
          route: '/DRE',
          method: 'DRE',
          categoria: 'auditoria',
          categoriaLabel: 'Auditoria',
          icon: 'folder',
          color: '#475569',
          badgeBg: '#f1f5f9',
          badgeColor: '#334155',
          description: 'Demonstrativo de Resultados do Exercício'
        }
      ]
    }
  },
  computed: {
    itensFiltrados() {
      const busca = (this.filtroBusca || '').trim().toLowerCase()
      const categoria = this.categoriaAtiva

      return this.menuItems.filter(item => {
        const matchCategoria = categoria === 'todos' || item.categoria === categoria
        if (!matchCategoria) return false

        if (!busca) return true

        const matchTitulo = item.title.toLowerCase().indexOf(busca) !== -1
        const matchDesc = item.description.toLowerCase().indexOf(busca) !== -1
        return matchTitulo || matchDesc
      })
    }
  },
  methods: {
    navegar(route) {
      if (route) {
        this.$router.push(route).catch(() => {})
      }
    },
    limparFiltros() {
      this.filtroBusca = ''
      this.categoriaAtiva = 'todos'
    },
    // Métodos legados preservados para compatibilidade total
    async Caixa() {
      this.$router.push('/caixa').catch(() => {})
    },
    async Boleto() {
      this.$router.push('/boleto').catch(() => {})
    },
    async Notas() {
      this.$router.push('/nota').catch(() => {})
    },
    async ConferenciaDiaria() {
      this.$router.push('/conferencia-diaria-notas').catch(() => {})
    },
    async ContasReceber() {
      this.$router.push('/contas-receber').catch(() => {})
    },
    async NotasEntrada() {
      this.$router.push('/notas-entrada').catch(() => {})
    },
    async Retorno() {
      this.$router.push('/retorno').catch(() => {})
    },
    async Cobranca() {
      this.$router.push('/cobranca').catch(() => {})
    },
    async DRE() {
      this.$router.push('/DRE').catch(() => {})
    },
    async ParaFaturar() {
      this.$router.push('/contratos-faturamento').catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.financeiro-hub-container {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  min-height: calc(100vh - 190px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 1rem 0.5rem 2rem 0.5rem;
}

.hub-header {
  .header-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}

.categoria-chips {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.chip-btn {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;

  &:hover {
    background: #e2e8f0;
    color: #1e293b;
  }

  &.chip-btn-active {
    background: #002750;
    color: #ffffff;
    border-color: #002750;
  }
}

.busca-wrapper {
  position: relative;
  min-width: 200px;

  .busca-input {
    width: 100%;
    padding: 6px 12px 6px 34px;
    font-size: 13px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background-color: #ffffff;
    color: #1e293b;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:focus {
      border-color: #002750;
      box-shadow: 0 0 0 2px rgba(0, 39, 80, 0.1);
    }

    &::placeholder {
      color: #94a3b8;
    }
  }

  .busca-icon {
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    pointer-events: none;
  }
}

.financeiro-grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 1.25rem;
  width: 100%;

  @media (min-width: 520px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  @media (min-width: 1280px) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

.card-fin-item {
  background: #ffffff;
  border: 1px solid #edf2f7;
  border-radius: 12px;
  padding: 1.25rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
  outline: none;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 39, 80, 0.12);
    border-color: rgba(0, 39, 80, 0.2);

    .card-arrow-indicator {
      opacity: 1;
      transform: translateX(0);
      color: #002750;
    }

    .card-icon-box {
      transform: scale(1.08);
    }
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px rgba(0, 39, 80, 0.25);
    border-color: #002750;
  }
}

.card-header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.categoria-badge {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 2px 8px;
  border-radius: 12px;
}

.card-arrow-indicator {
  opacity: 0;
  transform: translateX(-4px);
  transition: all 0.2s ease;
  color: #94a3b8;
  display: flex;
  align-items: center;
}

.card-icon-box {
  width: 60px;
  height: 60px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.card-title {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: 0.4px;
  margin: 0;
}

.card-description {
  font-size: 11.5px;
  color: #64748b;
  line-height: 1.35;
  margin: 4px 0 0 0;
  min-height: 32px;
}

.empty-state-hub {
  margin: 2rem auto;
  max-width: 450px;
}
</style>
